module.exports = "<div>\n  Toolbar\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/toolbar/toolbar.component.html
// module id = ../../../../../src/app/core/toolbar/toolbar.component.html
// module chunks = main